module.exports = __webpack_public_path__ + "img/icon-40.4416885e.svg";